import React from "react";
import {Redirect, Route, Switch, useLocation} from "react-router-dom";
import {
    getAcPageUrl,
    getGogglesAcPageUrl,
    getGogglesIapPageUrl,
    getGogglesIogPageUrl,
    getGogglesM2PageUrl,
    getIapPageUrl, getIogPageUrl
} from "../backend/internalUrls";
import * as queryString from "query-string";

const GogglesRedirects: React.FC = (props) => {
    const location = useLocation()
    const options = {skipEmptyString: true}

    return (
        <Switch>
            <Route
                exact
                path={getGogglesM2PageUrl(':marketplaceId', ':merchantCustomerId')}
                render={({match}) => (
                    <Redirect to={{
                        pathname: getAcPageUrl(),
                        search: queryString.stringifyUrl({
                                url: '',
                                query: {
                                    marketplaceId: match.params.marketplaceId,
                                    merchantCustomerId: match.params.merchantCustomerId,
                                    programId: queryString.parse(location.search).program_id as string,
                                    regionId: queryString.parse(location.search).region_id as string,
                                    fnsku: queryString.parse(location.search).fnsku as string
                                }
                            }, options
                        )
                    }}/>
                )}
            />
            <Redirect
                exact
                from={getGogglesAcPageUrl(':acId')}
                to={{
                    pathname: getAcPageUrl(':acId'),
                    search: queryString.stringifyUrl({
                            url: '',
                            query: {fnsku: queryString.parse(location.search).fnsku as string}
                        }, options
                    )
                }}
            />
            <Redirect
                exact
                from={getGogglesIapPageUrl(':iapId')}
                to={{
                    pathname: getIapPageUrl(':iapId'),
                    search: queryString.stringifyUrl({
                            url: '',
                            query: {fnsku: queryString.parse(location.search).fnsku as string}
                        }, options
                    )
                }}
            />
            <Redirect exact from={getGogglesIogPageUrl(':iogId')} to={{pathname: getIogPageUrl(':iogId')}} />
            <Route
                exact
                path={getGogglesIogPageUrl(':iogId', ':fc')}
                render={({match}) => (
                    <Redirect to={{pathname: getIogPageUrl(match.params.iogId), search: `?fcId=${match.params.fc}`}} />
                )}
            />
        </Switch>
    )
}

export default GogglesRedirects